// const subdomain = window.location.origin.match(/\/\/(\w+)\./)[1];
const { protocol, hostname } = window.location;
const port = process.env.REACT_APP_API_MOCK_PORT || (process.env.NODE_ENV === 'development' ? 3000 : null);
export const API_URL = `${protocol}//${hostname.replace(/surveys/, 'api')}${port ? `:${port}` : ''}`;
